import React from 'react';
import StatusBadge from '../ReusableComponents/StatusBadge';
export default function OrganizationDetails({ organization: o }) {
  const fields = [
    ['Nome da organizadora', o.name],
    ['CNPJ', o.cnpj],
    ['Razão social', o.razao_social],
    ['Nome fantasia', o.nome_fantasia],
    ['E-mail institucional', o.email_institucional],
    ['Telefone', o.telefone],
    ...[
      ['cep', 'CEP'],
      ['logradouro', 'Logradouro'],
      ['numero', 'Número'],
      ['complemento', 'Complemento'],
      ['bairro', 'Bairro'],
      ['cidade', 'Cidade'],
      ['estado', 'Estado'],
    ].map(([key, label]) => [label, o.endereco?.[key]]),
  ];
  return (
    <>
      <dl className="portal-admin-facts organization-details">
        {fields.map(([label, value]) => (
          <div key={label}>
            <dt>{label}</dt>
            <dd>{value || 'Não informado'}</dd>
          </div>
        ))}
        <div>
          <dt>Portal de inscrições</dt>
          <dd>
            <StatusBadge variant={o.portal_enabled ? 'success' : 'secondary'}>
              {o.portal_enabled ? 'Habilitado' : 'Desabilitado'}
            </StatusBadge>
          </dd>
        </div>
        <div>
          <dt>Autenticação em dois fatores</dt>
          <dd><StatusBadge variant={o.two_factor_enabled ? 'success' : 'secondary'}>{o.two_factor_enabled ? 'Habilitada' : 'Desabilitada'}</StatusBadge></dd>
        </div>
        <div className="organization-description">
          <dt>Descrição</dt>
          <dd className="portal-admin-prose">{o.descricao || 'Não informada'}</dd>
        </div>
      </dl>
    </>
  );
}
